class MnSaleCountdown extends HTMLElement {
  connectedCallback() {
    this.dayNodes = this.querySelectorAll('[data-days]');
    this.units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.isEditor = window.Shopify && window.Shopify.designMode === true;
    this.repeating = this.dataset.mode === 'repeat';
    this.duration = (Number(this.dataset.duration) > 0 ? Number(this.dataset.duration) : 900) * 1000;

    if (this.repeating) {
      const now = Date.now();
      this.cycleStart = now;
      const key = `mn-countdown:${this.dataset.key}:${this.duration}`;
      try {
        const saved = Number(window.localStorage.getItem(key));
        this.cycleStart = Number.isFinite(saved) && saved > 0 && saved <= now ? saved : now;
        if (this.cycleStart !== saved) window.localStorage.setItem(key, String(this.cycleStart));
      } catch (e) {
        /* storage unavailable */
      }
    } else {
      const value = (this.dataset.endAt || '').trim();
      this.deadline = Date.parse(value);
    }

    this.tick();
    clearInterval(this.timer);
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const now = Date.now();
    let remaining;
    if (this.repeating) {
      remaining = Math.ceil((this.duration - (Math.max(0, now - this.cycleStart) % this.duration)) / 1000);
    } else {
      remaining = Math.max(0, Math.ceil((this.deadline - now) / 1000));
    }

    if (!Number.isFinite(remaining) || remaining <= 0) {
      if (!this.isEditor) this.hidden = true;
      clearInterval(this.timer);
      return;
    }

    const days = Math.floor(remaining / 86400);
    this.dayNodes.forEach((node) => (node.hidden = days < 1));
    const values = [days, Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
    ['days', 'hours', 'minutes', 'seconds'].forEach((name, i) => {
      const node = this.units[name];
      const text = String(values[i]).padStart(2, '0');
      if (node && node.textContent !== text) node.textContent = text;
    });
    this.hidden = false;
  }
}

if (!customElements.get('mn-sale-countdown')) customElements.define('mn-sale-countdown', MnSaleCountdown);
